import { createFileRoute } from '@tanstack/react-router'

import { TabletNotFoundState } from '@/widgets/tablet/not-found-state'

export const Route = createFileRoute('/_tablet-layout/')({
    component: () => <TabletNotFoundState variant='invalid-link' />,
})
